import ClampsTooltip from 'projectDesign/components/projectConfiguration/fieldsTooltips/clampsTooltip';
import { makeAllRoofsEmpty } from '__editor/components/roofsSelector/components/roofsSelectorDrawingManager/roofsSelectorDrawingManager';
import { anyPanelsDrawn } from '__editor/googleMapsRoofsSelector/components/drawingManager/drawingManagerHelper'; 
import { CLAMP_FIELD_TITLE, CLAMP_FIELD_CONTENT } from './smClamps';

export const apiField = 'clamp_type';

export const ulaClampsType = (clamp_option_flag) => {
  return {
  type: 'Select',
  apiField: 'clamp_type',
  label: 'clamp_options',
  tooltip: ClampsTooltip,
  title: CLAMP_FIELD_TITLE,
  content: CLAMP_FIELD_CONTENT,
  onConfirm: () => {
    makeAllRoofsEmpty();
  },
  shouldConfirm: () => anyPanelsDrawn(),
  data: [
    ...(clamp_option_flag ? [ {value: '11', name: 'PRO SERIES',},]:[]),
      {
        value: '01',
        name: 'STANDARD',
      },
      {
        value: '04',
        name : 'UNIVERSAL AF CLAMPS'
      }
    ],
  }
};

export const gftClampsType = (rail_arrangement_type) => {
  return {
  type: 'Select',
  apiField: 'clamp_type',
  label: 'clamp_options',
  tooltip: ClampsTooltip,
  title: CLAMP_FIELD_TITLE,
  content: CLAMP_FIELD_CONTENT,
  onConfirm: () => {
    makeAllRoofsEmpty();
  },
    shouldConfirm: () => anyPanelsDrawn(),
    data: [
    {
      value: '11',
      name: 'PRO SERIES',
    },
    {
      value: '01',
      name: 'STANDARD',
    },
    ...((rail_arrangement_type === 3 || rail_arrangement_type === 1)? []:[{ value:'04', name:'UNIVERSAL AF CLAMPS' }]),
  ],
  };
};
